import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const apiClient = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});

export const submitContact = (payload) =>
  apiClient.post("/contact", payload).then((r) => r.data);

export const submitStory = (payload) =>
  apiClient.post("/stories", payload).then((r) => r.data);

export const subscribeNewsletter = (email) =>
  apiClient.post("/newsletter", { email }).then((r) => r.data);

export const exchangeSession = (session_id) =>
  apiClient.post("/auth/session", { session_id }).then((r) => r.data);

export const fetchMe = () => apiClient.get("/auth/me").then((r) => r.data);

export const logout = () => apiClient.post("/auth/logout").then((r) => r.data);

export const listContacts = () =>
  apiClient.get("/contact").then((r) => r.data);

// ---------- Journal ----------
export const fetchJournalList = () =>
  apiClient.get("/journal").then((r) => r.data);

export const fetchJournalPost = (slug) =>
  apiClient.get(`/journal/${slug}`).then((r) => r.data);

export const adminListJournal = () =>
  apiClient.get("/admin/journal").then((r) => r.data);

export const adminGetJournal = (id) =>
  apiClient.get(`/admin/journal/${id}`).then((r) => r.data);

export const adminCreateJournal = (payload) =>
  apiClient.post("/admin/journal", payload).then((r) => r.data);

export const adminUpdateJournal = (id, payload) =>
  apiClient.put(`/admin/journal/${id}`, payload).then((r) => r.data);

export const adminDeleteJournal = (id) =>
  apiClient.delete(`/admin/journal/${id}`).then((r) => r.data);

export const uploadImage = (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return apiClient
    .post("/admin/uploads", fd, { headers: { "Content-Type": "multipart/form-data" } })
    .then((r) => r.data);
};

// ---------- Stories ----------
export const fetchPublishedStories = () =>
  apiClient.get("/stories").then((r) => r.data);

export const adminListStories = () =>
  apiClient.get("/admin/stories").then((r) => r.data);

export const adminPatchStory = (id, patch) =>
  apiClient.patch(`/admin/stories/${id}`, patch).then((r) => r.data);

export const adminDeleteStory = (id) =>
  apiClient.delete(`/admin/stories/${id}`).then((r) => r.data);
